import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MatDialogConfig } from '@angular/material/dialog';
import { List } from 'immutable';
import { UserMapping } from '../model/usermapping'
import { DeleteUserDialogComponent } from './delete-user-dialog.component'
import { EditUserDialogComponent } from './edit-user-dialog.component'
import { CreateUserDialogComponent } from './create-user-dialog.component';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { UserMappingService } from '../services/usermapping.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit, AfterViewInit {

  deleteUserModalRef: MatDialogRef<DeleteUserDialogComponent>;
  createUserModalRef: MatDialogRef<CreateUserDialogComponent>;
  editUserModalRef: MatDialogRef<EditUserDialogComponent>;


    
  public userMappings: List<UserMapping>;

  public displayedColumns = ['name', 'loginID', 'roles', 'employmentNumber', 'userCheckIn'];
  public dataSource: MatTableDataSource<UserMapping>;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private readonly dialog: MatDialog,
    private readonly toastr: ToastrService,
    private readonly usermappingService: UserMappingService) {

  }

  ngOnInit() {

    this.usermappingService.UserMappings.subscribe(result => {
      this.userMappings = result.sortBy(u => u.name).toList();
      this.dataSource = new MatTableDataSource(this.userMappings.toArray());
    }, error => console.error(error));

  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  //Show Edit dialog
  onRowClick(userMapping: UserMapping) {
    console.log("rowClick", userMapping);

    let self = this;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "600px";
    dialogConfig.panelClass = "userDialog";
    dialogConfig.data = userMapping;
    self.editUserModalRef = self.dialog.open(EditUserDialogComponent, dialogConfig);
  }

  //Show delete dialog
  onDelete(userMapping: UserMapping) {
    console.log("Delete", userMapping);
    let self = this;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "600px";
    dialogConfig.data = userMapping;
    self.deleteUserModalRef = self.dialog.open(DeleteUserDialogComponent, dialogConfig);
  }

  //Show create dialog
  onNew() {
    console.log("New");
    let self = this;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "600px";
    dialogConfig.data = {
      userMapping: new UserMapping({})
    };
    self.createUserModalRef = self.dialog.open(CreateUserDialogComponent, dialogConfig);
  }

  openEditUser(userMapping: UserMapping) {
    let self = this;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "600px";
    dialogConfig.data = {
      userMapping: userMapping
    };
    self.editUserModalRef = self.dialog.open(EditUserDialogComponent, dialogConfig);

  }

  openCreateUser() {
    let self = this;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "600px";
    dialogConfig.data = {
      userMapping: new UserMapping({})
    };
    self.createUserModalRef = self.dialog.open(CreateUserDialogComponent, dialogConfig);
  }

  openDeleteUser(userMapping: UserMapping) {

    let self = this;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = "600px";
    dialogConfig.data = {
      userMapping: userMapping
    };
    self.deleteUserModalRef = self.dialog.open(DeleteUserDialogComponent, dialogConfig);

  }

  checkInOrOut(user: UserMapping) {

      let checkIn = true;
      if (user.userCheckIn !== undefined && user.userCheckIn !== null) {
        checkIn = user.userCheckIn.checkOut != null;
      }

      this.usermappingService.userCheckInOrOut(user.id, checkIn).then(res => {
        if (checkIn) {
          this.toastr.success(`${user.name} är nu incheckad`, 'Uppdatering');
        }
        else {
          this.toastr.success(`${user.name} är nu utcheckad`, 'Uppdatering');
        }
      }).catch((res: HttpErrorResponse) => {
        this.toastr.error(`Något gick fel när person checkades in/ut. ${res.error}`, 'Fel');
        console.log("Something went wrong while updating checkIn:", res);
      });
  }

  isCheckedIn(user: UserMapping) {
    if (user.userCheckIn != null) {
      return user.userCheckIn.checkOut == null;
    }
    return false;
  }

}

